var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.119 14.198a9.682 9.682 0 0 0-6.846 16.527A9.68 9.68 0 0 0 33.8 23.879a9.692 9.692 0 0 0-9.681-9.68ZM38.02 15.06a4.411 4.411 0 1 0 0-8.823 4.411 4.411 0 0 0 0 8.822Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m43.45 15.08-.185-.405-.295.334a6.638 6.638 0 0 1-2.66 1.831l-.285.105.116.278a17.205 17.205 0 0 1 1.331 6.657c0 9.57-7.785 17.352-17.352 17.352-9.568 0-17.352-7.783-17.352-17.352 0-9.57 7.782-17.352 17.352-17.352a17.157 17.157 0 0 1 7.437 1.678l.272.123.118-.277a6.654 6.654 0 0 1 1.96-2.567l.347-.278-.395-.196a21.014 21.014 0 0 0-9.74-2.37c-11.71 0-21.24 9.528-21.24 21.239s9.53 21.24 21.24 21.24c11.712 0 21.24-9.529 21.24-21.24a21.068 21.068 0 0 0-1.909-8.8Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/Ionic.b33205a87ceb3d650186b3e77c302007.svg";
export { ForwardRef as ReactComponent };